export const FEDERATION_SUPPORTED_TYPES = ['script'];
